import React from "react";
import { Segment, Image, Header, Breadcrumb, Divider } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";

const HeaderDivider = () => <div className="divider small"></div>;

const RegionWithHeader = (props) => {
  return (
    <Segment loading={props.loading} basic={props.basic} title="" className={`region ${props.className && props.className}`} >
      <div className="region-header">
        <Header
          className="region-header-left"
          color={props.headerColor}
          size={props.headerSize}
        >
          <FormattedMessage id={props.title} />
          <HeaderDivider />
        </Header>
        {props.headerIconSrc ? (
          <Image
            src={props.headerIconSrc}
            as="img"
            size="tiny"
            floated="right"
          />
        ) : null}

        {props.headerAction ? <div>{props.headerAction}</div> : null}
      </div>
      <div className="region-content">{props.children}</div>
      <div className="region-footer">
        <div className="footerLeft">{props.leftFooter && props.leftFooter}</div>
        <div className="footerRight">
          {props.rightFooter && props.rightFooter}
        </div>
      </div>
    </Segment>
  );
};

const RegionWithoutHeader = (props) => {
  return (
    <Segment className="region"  {...props}>
      <div className="region-content">{props.children}</div>
    </Segment>
  );
};

const BreadCrumb = ({data = ["Cession de Capture" ], size, onClickItem = () => {}}) => {
  const length = data.length || 0;
  const isCurrent = (index) => {return index+1 === length}
  return (
    length > 0 && 
    <><Breadcrumb  size={size} className="mb-2">
        {
          length === 1 && <Breadcrumb.Section active onClick={() => onClickItem(data[0])}>{data[0]}</Breadcrumb.Section>
        }
        {
          length > 1 && data.map((item, index) => {
            return <span key={item}>
                <Breadcrumb.Section  
                  active={isCurrent(index)} 
                  link={!isCurrent(index)}
                  onClick={() => onClickItem(item)}
                  >{item}</Breadcrumb.Section>
                {!isCurrent(index) && <Breadcrumb.Divider  icon='right chevron' />}
            </span>
          })
        }
      </Breadcrumb>
      <Divider hidden />
      </>)
}


export default {
  RegionWithHeader,
  RegionWithoutHeader,
  BreadCrumb
};
